import { render, staticRenderFns } from "./pricePass.vue?vue&type=template&id=6a4619b4&scoped=true"
import script from "./pricePass.vue?vue&type=script&lang=js"
export * from "./pricePass.vue?vue&type=script&lang=js"
import style0 from "./pricePass.vue?vue&type=style&index=0&id=6a4619b4&prod&scoped=true&lang=css"
import style1 from "./pricePass.vue?vue&type=style&index=1&id=6a4619b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4619b4",
  null
  
)

export default component.exports